/**
 * O `POST /v2/auth/validate-code` devolve `gender` (`m` | `f`) quando o cadastro já tem o gênero definido.
 * Vazio (ou valor desconhecido) devolve `null`: a jornada pergunta o gênero antes do equipamento, senão a
 * cotação seguiria com `gender` vazio (mesma regra do chat legado, PR #129).
 */
export function genderFromValidateCode(raw: string | null | undefined): 'm' | 'f' | null {
  const value = (raw ?? '').trim().toLowerCase();
  if (value === 'm' || value === 'masculino') return 'm';
  if (value === 'f' || value === 'feminino') return 'f';
  return null;
}
